import { Component, OnChanges } from '@angular/core';

import { HsgModal } from '@hhsg/hsg-asc';

import { BaseShiftBlockGridComponent } from '../../base-grid/base-shiftblock-grid/base-shiftblock-grid.component';
import { CostCenterConfigurationService } from 'src/shared/services/cost-center-configuration.service';
import { JobShiftCell } from '../../models/job-shift-cell.model';
import { JobTitle } from 'src/shared/models/job-title.model';
import { ShiftBlock } from 'src/shared/models/shift-block.model';
import { StaffingGridModalComponent } from '../../staffing-grid-modal/staffing-grid-modal.component';
import { StaffingGridUtil } from '../../utilities/staffing-grid.util';
import { WorkflowPageUtil } from 'src/app/workflow/base-classes/workflow-page/workflow-page.util';

@Component({
    selector: 'smt-fixed-jobs-shift-grid',
    templateUrl: './fixed-jobs-shift-grid.component.html',
    styleUrls: ['./fixed-jobs-shift-grid.component.scss']
})
export class FixedJobsShiftGridComponent extends BaseShiftBlockGridComponent implements OnChanges {
    fixedStaffingGrid: JobShiftCell[][];
    jobTitles: JobTitle[];

    constructor(private _costCenterConfigurationService: CostCenterConfigurationService, private _modal: HsgModal) { 
        super(_costCenterConfigurationService);
        super.initializeGridProcess(() => this.buildFixedGrid(), () => this.initializeFixedGrid());
    }

    ngOnChanges() {
        this.jobTitles = this.costCenter.fixedJobTitles;   
        super.Process();     
    }   

    buildFixedGrid(): JobShiftCell[][] {
        if (!this.jobTitles || !this.shiftBlocks) {
            return;
        }        

        let cells = [] as JobShiftCell[];
      let columnCounter = 0;
      
        this.shiftBlocks.sort(s => s.startHour).forEach(s => {
            //this.jobTitles.sort(s=> s.order).forEach(j => {
            this.jobTitles.forEach(j => {
                cells.push(this.buildGridCell(columnCounter.toString(), j.id, "0", s));

                ++columnCounter;
            });
        });

        this.fixedStaffingGrid = this.sortRowIntoGrid(cells);

        return this.fixedStaffingGrid;
    }

    private buildGridCell(columnId: string, jobTitleId: number, rowId: string, shiftBlock: ShiftBlock): JobShiftCell {
        let cell = new JobShiftCell();

        cell.columnId = columnId;
        cell.id = rowId + '-' + shiftBlock.id + '-' + jobTitleId;        
        cell.jobTitleId = jobTitleId;
        cell.rowId = rowId;
        cell.shiftBlockId = shiftBlock.id;
        cell.startHour = shiftBlock.startHour;

        if (!(jobTitleId in shiftBlock.staffingGrid)) {
            shiftBlock.staffingGrid[jobTitleId] = {};
        }

        cell.value = shiftBlock.staffingGrid[jobTitleId][-1];

        return cell;
    }

    cellKeyPressed(currentCell: JobShiftCell){
        this.updateCell(currentCell);        
    }

    initializeFixedGrid() {
        this.jobTitles = this.costCenter.fixedJobTitles;
        super.setShiftBlocksFromSchedule();
    }

    get isInputRequired(): boolean {
        let hasInpatient = WorkflowPageUtil.hasInpatientConfiguration(this.costCenter);

        return (hasInpatient && !this.costCenter.inactiveDate) || !hasInpatient;
    }

    onCopy() {
        this.setShiftBlocksFromCopy();
    
        this.copyShiftBlocks.forEach(sourceBlock => {
            let targetBlock = this.shiftBlocks.find(b => b.startHour === sourceBlock.startHour);
    
            this.jobTitles.forEach(jobTitle => {
                if (jobTitle.id in targetBlock.staffingGrid && jobTitle.id in sourceBlock.staffingGrid) {
                    targetBlock.staffingGrid[jobTitle.id] = {};
    
                    Object.keys(sourceBlock.staffingGrid[jobTitle.id]).forEach(censusCount => {
                        targetBlock.staffingGrid[jobTitle.id][censusCount] = sourceBlock.staffingGrid[jobTitle.id][censusCount];
                    });
                }
            });
        });
    
        this.fixedStaffingGrid = this.buildFixedGrid();
        this._costCenterConfigurationService.announceFormIsDirty(true);
        return false;
    }

    onViewFullStaffingGrid() {
        this._modal.open(
            StaffingGridModalComponent, 
            {
                data: {
                    title: this.setModalTitle(),
                    size: { width: '100%', height: '100%' },
                    isVariable: false,
                    minCensus: 0,
                    maxCensus: 0,
                    jobTitles: this.jobTitles,
                    selectedShiftBlocks: this.shiftBlocks,
                    selectedMaxCensus: 0,
                    selectedCensusTable: this.fixedStaffingGrid
                }
            });
        return false;
    }

    private setModalTitle(): string {
        let isWeekday = StaffingGridUtil.isGridTypeWeekday(this.gridType);
        let modalTitle = '';

        if (isWeekday) {
            modalTitle = "Weekday";
        }
        else {
            modalTitle = "Weekend";
        }

        modalTitle += " Fixed Staffing Grid";    
        
        return modalTitle
    }

    private setShiftBlocksForSave() {
        if (this.shiftBlocks) {
            this.shiftSchedule.partialShiftBlocks = this.shiftBlocks;
        }        
    }

    showInpatientButtons(): boolean {
        return WorkflowPageUtil.hasInpatientConfiguration(this.costCenter);
    }

    private sortRowIntoGrid(cells: JobShiftCell[]): JobShiftCell[][] {
        let sortedTable: JobShiftCell[][] = []; 
        let sortedRow: JobShiftCell[] = [];
    
        this.shiftBlocks.sort(s => s.startHour).forEach(s => {
            let columnCounter = 0;

            //this.jobTitles.sort(j=> j.order).forEach(j => { 
            this.jobTitles.forEach(j => {                                       
                let cell = cells.find(c => c.jobTitleId == j.id && c.shiftBlockId == s.id);
    
                if (cell) {
                    sortedRow.push(cell);
                } 
                else {
                    let newCell = new JobShiftCell();
                    newCell.rowId = "0";
                    newCell.columnId = columnCounter.toString();
                    newCell.shiftBlockId = s.id;
                    newCell.startHour = s.startHour;
                    newCell.value = s.staffingGrid[j.id][-1];
                    sortedRow.push(newCell);                    
                }

                ++columnCounter;
            });
        });
    
        sortedTable.push(sortedRow);
    
        return sortedTable;
    }     

    private updateCell(currentCell: JobShiftCell) {
        let shiftBlock = this.shiftBlocks.find(b => b.startHour === currentCell.startHour);
    
        if (!shiftBlock) {
            return;
        }

        let staffCount = currentCell.value;
    
        if (!shiftBlock.staffingGrid) {
            shiftBlock.staffingGrid = {};
        }

        if (!StaffingGridUtil.gridContainsValidJobTitle(currentCell.jobTitleId, shiftBlock, true)) {
            shiftBlock.staffingGrid[currentCell.jobTitleId] = {};
        }
    
        if (staffCount || staffCount === 0) {
            staffCount = +staffCount;
        } 
        else {
            staffCount = null;
        }
    
        shiftBlock.staffingGrid[currentCell.jobTitleId][-1] = staffCount;        

        StaffingGridUtil.checkCompleteJobsShiftGrid(
            this.costCenter.fixedJobTitles, 
            this.shiftSchedule,
            true);

        this.setShiftBlocksForSave();

        this._costCenterConfigurationService.announceFormIsDirty(true);
    }
}
